import {CommonMessageType} from 'electron-communication-lib/CommonForApp';

import {getStoredSilentLoginCred} from '@ELib/utilities/LocalStorage';
import {useCommonMessageExchange} from '@ELib/utilities/hooks/useElectronMessageExchange';
import {makeRequest} from '@ELib/utilities/requests';

let localBaseURL = '/auth/rest/public/authentication';
let localSessionType = 'default-application';

const defaultRequestParameters = {
  headers: {
    'Content-Type': 'application/json',
    'X-Same-Domain': '1',
  },
  method: 'POST',
};

export const setLocalBaseURL = (url: string): void => {
  localBaseURL = url;
};
export const setLocalSessionType = (sessionType: string): void => {
  localSessionType = sessionType;
};

export const checkPW = async (
  username: string,
  password: string
): Promise<{ok: boolean; code?: string}> => {
  const response = await makeRequest(`${localBaseURL}/password/check`, {
    username,
    password,
  });

  if (!response) {
    return {ok: false};
  }

  if (response.status === 200) {
    return {ok: true};
  }

  const responseBody = (await response.json()) as
    | {errors?: {code?: string}[]}
    | undefined;
  return {ok: false, code: responseBody?.errors?.[0]?.code};
};

export const initAuthSession = async (): Promise<number | undefined> => {
  const response = await makeRequest(
    `${localBaseURL}/${localSessionType}/access/`
  );
  return response?.status;
};

export const abortAuthenticationFlow = async (): Promise<boolean> => {
  const response = await fetch(`${localBaseURL}`, {
    ...defaultRequestParameters,
    method: 'DELETE',
  });
  return response.status === 204;
};

/**
 * useKeyChainResponse is used to log the user in if the keychain has the necessary credentials saved
 */
export const useKeyChainResponse = (
  onSuccess: (data?: unknown) => void
): void => {
  const username = getStoredSilentLoginCred();

  useCommonMessageExchange({
    message: {
      type: CommonMessageType.GET_LOGIN_CREDENTIALS,
      payload: username ?? undefined,
    },
    responsePayloadHandler: (payload: string) => {
      if (username && payload) {
        checkPW(username, payload).then(({ok}) => {
          if (ok) {
            onSuccess();
          }
        });
      }
    },
    dependencies: [username, onSuccess],
  });
};
